import MessageInput from './MessageInput';

const message = {
  id: 'message',
  name: 'Message',
  Input: MessageInput,
  setInitialContent: content => {
    return {
      type: content.type || 'text',
      placeholder: content.placeholder || 'Send a message',
      disabled: content.disabled !== undefined ? content.disabled : false,
      show_file_upload:
        content.show_file_upload !== undefined
          ? content.show_file_upload
          : false
    };
  },
  formatContent: content => {
    return {
      type: content.type,
      placeholder: content.placeholder,
      disabled: content.disabled,
      show_file_upload: content.show_file_upload
    };
  },
  valid: content => {
    return Boolean(content.placeholder);
  },
  snippet: `{
    "type": "message",
    "content": {
      "type": "text",
      "placeholder": "Send a message",
      "disabled": false,
      "show_file_upload": false
    }
}`
};

export default message;
